"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "12",
  height: "10",
  viewBox: "0 0 12 10"
}, _react.default.createElement("path", {
  d: "M11.05 1a3.35 3.35 0 00-3.7-.74c-.41.17-.78.42-1.1.74-.07.07-.15.22-.22.3-.08-.08-.15-.23-.23-.3A3.35 3.35 0 002.1.26c-.4.17-.78.42-1.09.74a3.3 3.3 0 00-.75 3.64c.18.4.43.77.75 1.08l4.33 4.01c.39.36.99.36 1.37 0l4.34-4.01a3.4 3.4 0 000-4.72z"
}));

exports.default = _default;